import React from 'react';
import { Helmet } from 'react-helmet-async';

// docs/SEO-AUDIT.md §6.1 — Organization/WebSite/BlogPosting/FAQPage/
// BreadcrumbList schema, one <script type="application/ld+json"> per
// call. Needed prerendering (§1.1) to be reliably read by anything that
// doesn't execute JS — Google's Rich Results Test runs JS, but most
// other consumers don't.
//
// Render each JsonLd as a direct child, never wrapped in a Fragment or
// other element — react-helmet-async only walks direct children of
// <Helmet>/<HelmetProvider>'s tree; a wrapping element silently drops
// whatever's inside it with no error (see PageMeta.jsx's og:image history
// for the same trap).
const JsonLd = ({ data }) => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(data)}</script>
  </Helmet>
);

export default JsonLd;
